import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React from 'react';
import {
  FaFlask,
  FaFont,
  FaHashtag,
  FaTrash,
} from 'react-icons/fa';
import {
  Button,
  ButtonGroup,
  Label,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
} from 'reactstrap';

import StoreContext from '../../../stores';

const chunk = (arr, size) => {
  const chunks = [];
  let idx = 0;

  while (idx < arr.length) {
    chunks.push(arr.slice(idx, size + idx));
    idx += size;
  } 
  return chunks;
};

const ISalesSoftTab = ({
  canEdit,
  iSalesUserName = '',
  crmID,
  onChange,
  profiles,
  allowSelfEdit,
}) => {
  const {
    userStore,
  } = React.useContext(StoreContext);

  const networkFields = toJS(userStore.user.network.availibleCRMs.iSalesCRM.fields);

  const createProfile = () => {
    if (canEdit) {
      onChange(crmID, 'profiles', profiles.concat([{
       // crmExcludeUserID: false,
        crmFields: Object.keys(networkFields).reduce(
          (acc, fieldProp) => ({
            ...acc,
            [fieldProp]: '',
          }),
          {},
        ),
        id: `iSalesCRM${profiles.length + 1}`,
      }]));
    }
  };

  const deleteProfile = deleteIdx => {
    if (canEdit) {
      onChange(crmID, 'profiles', profiles.filter(
        (profile, idx) => idx !== deleteIdx,
      ));
    }
  };

  const setProfileField = (setIdx, fieldName, fieldValue) => {
    if (canEdit) {
      onChange(crmID, 'profiles', profiles.map(
        (profile, idx) => idx === setIdx ? {
          ...profile,
          [fieldName]: fieldValue,
        } : profile,
      ));
    }
  };

  const setProfileCRMField = (setIdx, fieldName, fieldValue) => {
    if (canEdit) {
      setProfileField(setIdx, 'crmFields', {
        ...profiles[setIdx].crmFields,
        [fieldName]: fieldValue,
      });
    }
  };


  const displayProfiles = profiles.length > 1;

  return (
    <div>
    <FormGroup>
    <Label>ISalesCRM Email</Label>
    <Input
      type="email" 
      disabled={!allowSelfEdit}
      name="iSalesUserName"
      onChange={e => onChange(crmID, 'iSalesUserName', e.target.value)}
      value={iSalesUserName}
    />
    <FormText>Enter the email you use to log into ISalesCRM</FormText>
  </FormGroup>
 <Table style={{
      userSelect: 'none',
    }}>
      <thead>
        <tr>
          <th style={{ width: '50px' }}>Profiles</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {profiles.map(
          (profile, profileIdx) => (
            <tr key={profile.id}>
              <td>
                <span>
                  <FaHashtag style={{ marginBottom: '12px' }} />
                  <h4 style={{ display: 'inline' }}>{profileIdx + 1}</h4>
                </span>
                {canEdit && (
                  <ButtonGroup vertical>
                    <Button
                      color="info"
                      disabled
                      title="Test profile (COMING SOON)" // TODO: Add this
                    >
                      <FaFlask />
                    </Button>
                    <Button
                      color="danger"
                      onClick={() => deleteProfile(profileIdx)}
                      title="Delete profile"
                    >
                      <FaTrash />
                    </Button>
                  </ButtonGroup>
                )}
              </td>
              <td>
                <Table>
                  <thead>
                    <tr>
                      <th style={{
                        border: 'none',
                        width: '50%',
                      }} />
                      <th style={{ border: 'none' }} />
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        colSpan="2"
                        style={{ border: 'none' }}
                      >
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">Description</InputGroupAddon>
                          <Input
                            disabled={!canEdit}
                            invalid={!profile.description}
                            onChange={e => setProfileField(profileIdx, 'description', e.target.value)}
                            placeholder="A descriptive name for this profile"
                            type="string"
                            value={profile.description}
                          />
                          <InputGroupAddon addonType="append">
                            <InputGroupText>
                              <FaFont title="text" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <FormFeedback>This field is required</FormFeedback>
                        </InputGroup>
                      </td>
                    </tr>
                    {chunk(
                      Object.keys(networkFields).map(
                        fieldProp => ({
                          ...networkFields[fieldProp],
                          fieldProp,
                        }),
                      ),
                      2,
                    ).map(
                      (chunk, chunkIdx) => (
                        <tr key={`chunk:${chunkIdx}`}>
                          <td style={{ border: 'none' }}>
                            <InputGroup>
                              <InputGroupAddon addonType="prepend">{chunk[0].label}</InputGroupAddon>
                              <Input
                                disabled={!canEdit}
                                invalid={chunk[0].required && !(profile.crmFields || {})[chunk[0].fieldProp]}
                                onChange={e => setProfileCRMField(profileIdx, chunk[0].fieldProp, e.target.value)}
                                placeholder={chunk[0].placeholder}
                                type={chunk[0].type}
                                value={(profile.crmFields || {})[chunk[0].fieldProp]}
                              />
                              <InputGroupAddon addonType="append">
                                <InputGroupText>
                                  {chunk[0].type === 'number' ?
                                    <FaHashtag title="number" /> :
                                    <FaFont title="text" />
                                  }
                                </InputGroupText>
                              </InputGroupAddon>
                              <FormFeedback>This field is required</FormFeedback>
                            </InputGroup>
                          </td>
                          <td style={{ border: 'none' }}>
                            {chunk.length === 2 && (
                              <InputGroup>
                                <InputGroupAddon addonType="prepend">{chunk[1].label}</InputGroupAddon>
                                <Input
                                  disabled={!canEdit}
                                  invalid={chunk[1].required && !(profile.crmFields || {})[chunk[1].fieldProp]}
                                  onChange={e => setProfileCRMField(profileIdx, chunk[1].fieldProp, e.target.value)}
                                  placeholder={chunk[1].placeholder}
                                  type={chunk[1].type}
                                  value={(profile.crmFields || {})[chunk[1].fieldProp]}
                                />
                                <InputGroupAddon addonType="append">
                                  <InputGroupText>
                                    {chunk[1].type === 'number' ?
                                      <FaHashtag title="number" /> :
                                      <FaFont title="text" />
                                    }
                                  </InputGroupText>
                                </InputGroupAddon>
                                <FormFeedback>This field is required</FormFeedback>
                              </InputGroup>
                            )}
                          </td>
                        </tr>
                      ),
                    )}
                  </tbody>
                   {/*   <tfoot>
                <tr>
                      <td colSpan="2" style={{ border: 'none' }}>
                        {canEdit && (
                          <FormGroup>
                            <CustomInput
                              checked={profile.crmExcludeUserID}
                              id={`crmExcludeUserID${profileIdx}`}
                              label="Exclude CRM user ID"
                              onChange={() => setProfileField(profileIdx, 'crmExcludeUserID', !profile.crmExcludeUserID)}
                              type="checkbox"
                            />
                          </FormGroup>
                        )}
                      </td>
                    </tr>
                        </tfoot>*/}
                </Table>
              </td>
            </tr>
          ),
        )}
      </tbody>
      <tfoot>
      {canEdit &&  <tr>
          <td colSpan="2">
            <Button
              color="success"
              onClick={() => createProfile()}
            >
              Add New Profile
            </Button>
          </td>
        </tr>}
      </tfoot>
      </Table> 
    </div>
  );
};

ISalesSoftTab.defaultProps = {
  profiles: [],
};

ISalesSoftTab.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  iSalesUserName: PropTypes.string,
  //crmCampaign: PropTypes.string.isRequired,
  crmID: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  allowSelfEdit: PropTypes.bool,
  profiles: PropTypes.arrayOf(PropTypes.shape({
  //  crmCampaign: PropTypes.string.isRequired,
   // crmExcludeUserID: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
  })),
};

export default observer(ISalesSoftTab);

/*import React, { useState  } from 'react';
import { Card, CardBody,Label, Input, InputGroup,InputGroupAddon,InputGroupText} from 'reactstrap';

const ISalesCRM = ({onChange, sid, authToken, canEdit}) => {


  return (
 
    <Card body style={{ maxWidth: 900 }}>
        <CardBody>
     <InputGroup className="d-flex justify-content-end w-auto">
     <InputGroupAddon addonType="prepend">
          <InputGroupText>SID</InputGroupText>
        </InputGroupAddon>
     <Input 
        className="mr-1"
        type="text" 
        disabled={!canEdit}
        placeholder="Example: 233445"
        onChange={(e) => onChange(crmID, 'sid', e.target.value)}
        value={sid}
      />
           <InputGroupAddon addonType="prepend">
          <InputGroupText>Token</InputGroupText>
        </InputGroupAddon>
        <Input 
        type="text" 
        disabled={!canEdit}
        placeholder="Example: 1223324"
        onChange={(e) => onChange(crmID, 'authToken', e.target.value)}
        value={authToken}
      />
     </InputGroup>
   
      </CardBody>
    </Card>
  );
}

export default ISalesCRM;*/